import React from 'react';
export const CFIconAllDone = {
    alias: 'all-done',
    defaultTitle: 'All Done',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M16.616 6.213a.998.998 0 0 0-1.403.171l-7.055 9.008-3.379-4.197A1 1 0 0 0 3.22 12.45l4.17 5.178a1 1 0 0 0 .78.373h.006a.998.998 0 0 0 .78-.384l7.831-10a.998.998 0 0 0-.17-1.403Zm5 0a.998.998 0 0 0-1.403.171l-7.055 9.008-.604-.749-1.265 1.617 1.1 1.367c.191.236.477.373.78.373h.007a.998.998 0 0 0 .78-.384l7.831-10a.998.998 0 0 0-.17-1.403ZM9.98 11.445 8.713 13.06l-.492-.611a1 1 0 0 1 1.558-1.254l.201.249Z' }))),
};
